var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"formData",attrs:{"model":_vm.formData,"rules":_vm.rules,"size":"small","hide-required-asterisk":_vm.mode === 'static',"label-width":_vm.labelWidth,"label-position":"left"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }